// AT-2102 | AT-2161 | Ankur Makavana | 18-07-2023 | Reports to have to 2 sub-sections: 1. Mobile Reports Desktop 2. MIS Reports Reports Master - to be greyed out for now Finance Reports - to be greyed out for now Business Reports
import React from "react";
import customFetch from "./apicall/api";
import { logout, consolidate, filterData } from "./Utility";
import { ThemeContext } from "../context/IsLoader";
import {
  FileExcelOutlined,
  SearchOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import home_log from "../assets/images/home_logo.png";
import ReportHeader from "./Report_header";
import { queueService } from "../services/QueueService";
const e_designation_id = localStorage.getItem("e_designation_id");
class Report extends React.Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.state = {
      report_categories: [],
      isSpin: false,
      flag: 0,
    };
  }
  componentDidMount() {
    // Inject responsive body padding style only for this component
    this.reportBodyStyle = document.createElement('style');
    this.reportBodyStyle.setAttribute('data-report-body-padding', 'true');
    this.reportBodyStyle.innerHTML = `@media (max-width: 768px) { body { padding: 0 !important; } }`;
    document.head.appendChild(this.reportBodyStyle);

    if (
      window.Android &&
      typeof window.Android.getDataFromLocalStorage === "function"
    ) {
      const data = window.Android.getDataFromLocalStorage("your_key");
      document.head.appendChild(this.reportBodyStyle);
      if (data) {
        this.setState({ isSpin: false, flag: 1 });
        const tokenParts = data.split(",");
        const tokenData = {};

        tokenParts.forEach((part) => {
          const [key, value] = part.split(":");
          tokenData[key] = value;
        });

        if (
          tokenData.userid != "" &&
          tokenData.access_token != "" &&
          tokenData.effective_desgn_id != ""        ) {
          localStorage.setItem("in_userid", tokenData.userid);
          localStorage.setItem("api_token", tokenData.access_token);
          localStorage.setItem("designation_name", tokenData.designation_name);
          localStorage.setItem("employee_id", tokenData.employeeid);
          localStorage.setItem("em_branch_id", tokenData.em_branch_id);
          localStorage.setItem(
            "e_designation_id",
            tokenData.effective_desgn_id
          );
          localStorage.setItem("em_branch_id", tokenData.em_branch_id);
          localStorage.setItem("branch_id", tokenData.em_branch_id);
          localStorage.setItem("employee_id", tokenData.employeeid);
          localStorage.setItem("employee_name", tokenData.employee_name);
          
          // Start queue processing after successful login
          queueService.startProcessing();
          // this.props.history.push({
          //   pathname: "/Report",
          //   state: {
          //     api_token: tokenData.access_token,
          //     effective_designation_id: tokenData.effective_desgn_id,
          //   },
          // });
        } else {
          const { api_token } =
            (this.props.location && this.props.location.state) || {};
          localStorage.setItem("api_token", api_token);
        }
        console.log("AndroidInterface->", data);
      }
    } else {
      console.error(
        "Error in AndroidInterface: Android method not found or not available."
      );
      // Handle the error gracefully
    }

    this.setState({
      isSpin: true,
    });

    const categoriesRequestParams = new URLSearchParams({ employee_id: localStorage.getItem("employee_id") }).toString();
    const affiniltyRequestParams = new URLSearchParams({ userid: localStorage.getItem("in_userid") }).toString();

    const categoriesRequest = customFetch(
      process.env.REACT_APP_URL + "/get/list/categories/subcategories?" + categoriesRequestParams,
      {
        method: "GET",
        headers: { "api-token": localStorage.getItem("api_token") },
      }
    ).then((res) => res.json());

    const affinityRequest = customFetch(
      process.env.REACT_APP_URL + "/get/user/affinity?" + affiniltyRequestParams,
      {
        method: "GET",
        headers: { "api-token": localStorage.getItem("api_token") },
      }
    ).then((res) => res.json());

    Promise.allSettled([categoriesRequest, affinityRequest])
      .then((results) => {
        const categoriesData = results[0].status === 'fulfilled' ? results[0].value : {};
        const affinityData = results[1].status === 'fulfilled' ? results[1].value : [];
        
        this.setState({
          report_categories: categoriesData,
          affinity_list: (Array.isArray(affinityData) && affinityData[0] && affinityData[0].schema_names) || [],
          isSpin: false,
        });
      })
      .catch((error) => {
        console.log("Error fetching data", error);
        this.setState({
          isSpin: false,
        });
      });
  }

  componentWillUnmount() {
    // Remove the injected style tag
    if (this.reportBodyStyle && this.reportBodyStyle.parentNode) {
      this.reportBodyStyle.parentNode.removeChild(this.reportBodyStyle);
    }
  }

  render() {
    // const { api_token, effective_designation_id } =
    //   (this.props.location && this.props.location.state) || {};
    const effective_designation_id = parseInt(
      localStorage.getItem("e_designation_id")
    );
    const api_token = localStorage.getItem("api_token");
    const { report_categories } = this.state;
    return (
      <>
        {this.state.isSpin ? (
          <div className="preloader">
            <div className="loader" ng-hide="data.length > 0"></div>
          </div>
        ) : (
          ""
        )}
        <div className="container no-container ">
          {this.state.flag === 0 && (
            <ReportHeader
              title="Reports"
              showBack={false}
              onHome={() =>
                this.props.history.push({
                  pathname: "/dashboard",
                  state: { api_token },
                })
              }
              showLogout={true}
            />

          )}
          <div className="dashboard-card-holder row mt-4">
            {report_categories.categories &&
              report_categories.categories.map((categories, index) => (
                <>
                  <div className="image-report-2">
                    <div
                      className={
                        categories.status != "A" || !categories.is_accessible
                          ? "not-allowed m-2" : "m-2"
                      }
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/Report_categories",
                          state: {
                            api_token: api_token,
                            sub_categories: report_categories.sub_categories,
                            categories_id: categories.report_category_id,
                            categories_name: categories.category_name,
                            effective_designation_id: effective_designation_id,
                            hideHeader: this.state.flag === 0,
                            affinity_list: this.state.affinity_list,
                          },
                        });
                      }}
                    >
                      {categories.ui_img_path ? (
                        <img
                          src={require("../assets/images/" +
                            categories.ui_img_path)}
                          alt=""
                        />
                      ) : (
                        <img
                          src={require("../assets/images/check-list.png")}
                          alt=""
                        />
                      )}
                      <h5>{categories.category_name}</h5>
                    </div>
                  </div>
                </>
              ))}
          </div>
        </div>
      </>
    );
  }
}

export default Report;
